/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetFleetCoverageSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetFleetCoverageRequest = {
  /**
   * Optionally scope coverage to one provider's inventory (e.g. jamf), which excludes agent-only machines.
   */
  provider?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetFleetCoverageSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetFleetCoverageSecurity$outboundSchema: z.ZodMiniType<
  GetFleetCoverageSecurity$Outbound,
  GetFleetCoverageSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getFleetCoverageSecurityToJSON(
  getFleetCoverageSecurity: GetFleetCoverageSecurity,
): string {
  return JSON.stringify(
    GetFleetCoverageSecurity$outboundSchema.parse(getFleetCoverageSecurity),
  );
}

/** @internal */
export type GetFleetCoverageRequest$Outbound = {
  provider?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetFleetCoverageRequest$outboundSchema: z.ZodMiniType<
  GetFleetCoverageRequest$Outbound,
  GetFleetCoverageRequest
> = z.pipe(
  z.object({
    provider: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function getFleetCoverageRequestToJSON(
  getFleetCoverageRequest: GetFleetCoverageRequest,
): string {
  return JSON.stringify(
    GetFleetCoverageRequest$outboundSchema.parse(getFleetCoverageRequest),
  );
}
